
const api = {
  search: 'news/search',
  news: 'news',
  topicsRelations: 'news/topic/',
  topics: 'news/topics',
  bianmin: 'news/bianmin',
  rewen: 'hot',
  channels: 'news/channels',
  relationnews: 'news/getrelationnews',
  uarUrl:'news/recom'
};
export default api;


// WEBPACK FOOTER //
// ./app/web/asset/news-pc/js/api.js